import styles from './theme.module.scss';

export const textColorClass = (isDark = false): string => {
  if (isDark) {
    return styles.darkMode;
  }

  return styles.lightMode;
};
